// eslint-disable-next-line import/no-anonymous-default-export
export default {
  copyFromMaps: 'Google Maps\'ten kopyalayabilirsiniz'
};
